import React from 'react';

import { TranslatedMessage } from 'common/components/Intl';

export default class CommitmentText extends React.Component {
  renderAutoShipGreeting() {
    return (
      <div className="commitment-details__auto-ship-greeting text--large bold">
        <TranslatedMessage id={'account.membership.greeting'} />
      </div>
    );
  }

  renderCheckoutDisclaimer() {
    const {
      requiredInstallmentCount,
      maxQuantity,
      isSubscribed,
      name,
    } = this.props;
    const MIN_PODS_PER_SUBSCRIPTION = window.gon.minimumSubscriptionItems || 2;
    return (
      <div className="commitment-details__checkout-disclaimer">
        {isSubscribed && this.renderAutoShipGreeting()}
        <br />
        <div className="text">
          <TranslatedMessage
            id={'cart.commitment_text.disclaimer_with_installments'}
            values={{
              requiredInstallmentCount,
              name,
              minimumPodsSubscription: MIN_PODS_PER_SUBSCRIPTION,
            }}
          />
          <br />
          <TranslatedMessage
            id={'cart.commitment_text.limit'}
            values={{ maxQuantity, name }}
          />
        </div>
      </div>
    );
  }

  renderCancellationPolicy() {
    const { requiredInstallmentCount, cancellationFee } = this.props;

    return (
      <div className="commitment-details__cancellation-policy text">
        <TranslatedMessage
          id={'cart.commitment_text.cancellation_policy_with_installments'}
          values={{ cancellationFee, requiredInstallmentCount }}
        />
      </div>
    );
  }

  render() {
    return (
      <div className="commitment-details">
        {this.renderCheckoutDisclaimer()}
        <br />
        {this.renderCancellationPolicy()}
      </div>
    );
  }
}
